import { Skeleton } from "@/components/ui/skeleton";

export const SkeletonTable = () => {
  return (
    <div className="flex flex-col gap-4 max-w-7xl mx-auto mt-12">
      <Skeleton className="h-14 w-80 rounded-lg" />
      <div className="flex gap-4">
        <Skeleton className="h-10 w-96 rounded-lg" />
        <Skeleton className="h-10 w-24" />
      </div>
      <Skeleton className="h-10 max-w-full" />
      <Skeleton className="h-[200px] xl:h-[350px] 2xl:h-[500px]  max-w-full" />
    </div>
  );
};
